import './App.css';
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import Home from './pages/Home';



import Inscription from './pages/Inscription';
import NotFound from './components/NotFound/NotFound';
import Validationl from './pages/Validationl';


function App() {
  
  return (
    <>
      <Router>
        <Switch>
          <Route path="/" component={Home} exact/>
          <Route path="/ib" component={Validationl} exact/>
          <Route path="/inscription" component={Inscription} exact/>
          <Route exact component={NotFound} />
        </Switch>
      </Router>
    </>
  );
}

export default App;
